import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { roleType } from "../Utils/constant";

const Heading = ({ text, showMarquee = false }) => {
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.value
  );
  const navigate = useNavigate();
  return (
    <div className="pb-0 mt-1 mb-4">
      <div className="d-flex justify-content-between">
        <h4>{text}</h4>
        {/* {selectedRole === roleType.lender && (
          <button
            onClick={() => navigate("/submit-a-loan/form")}
            className="btn-primary col-sm-2 mb-1"
          >
            Submit a Loan
          </button>
        )} */}
      </div>
      <div className="bg-yellow overflow-hidden">
        {showMarquee && (
          <span className="d-flex py-3 my-marquee fs-5">
            This account currently has no active loans.
          </span>
        )}
      </div>
    </div>
  );
};

export default Heading;
